import { enableProdMode, importProvidersFrom } from '@angular/core';
import { environment } from './environments/environment';
import { AppComponent } from './app/app.component';
import { NgIdleKeepaliveModule } from '@ng-idle/keepalive';
import { ApiModule } from 'src/openapi-gen/api.module';
import { InMemoryScrollingOptions, PreloadAllModules, provideRouter, withComponentInputBinding, withInMemoryScrolling, withPreloading } from '@angular/router';
import { provideAnimations } from '@angular/platform-browser/animations';
import { bootstrapApplication } from '@angular/platform-browser';
import { APP_ROUTES } from './app/app.routes';
import { provideEnvironmentNgxMask } from 'ngx-mask';
import { AuthHttpRequestInterceptor } from './app/core/http-interceptors/auth.interceptor';
import { XsrfInterceptor } from './app/core/http-interceptors/antiforgery.interceptor';
import { HTTP_INTERCEPTORS, withInterceptorsFromDi, provideHttpClient } from '@angular/common/http';
import { RecaptchaInterceptor } from './app/core/http-interceptors/recaptcha.interceptor';
import { RECAPTCHA_V3_SITE_KEY, RecaptchaV3Module } from 'ng-recaptcha';
import './app/shared/extensions/string-extensions' 

if (environment.production) {
    window.console.log = () => {};
    window.console.debug = () => {};
    enableProdMode();
}

function getApiEndpoint() {
  return {
    // Note: The environment.apiUrl is used in development since a dedicated node server handles the Angular build
    rootUrl: environment.staging || environment.production ? window.location.origin : environment.apiUrl
  };
}

/**
 * Important: 
 * The ordering of the interceptors matter! 
 * Ensure the auth interceptor is last in the chain.
 */
const interceptorProviders = [];
interceptorProviders.push({ provide: HTTP_INTERCEPTORS, useClass: AuthHttpRequestInterceptor, multi: true });

if(environment.staging || environment.production) {
  interceptorProviders.push({ provide: HTTP_INTERCEPTORS, useClass: XsrfInterceptor, multi: true });
  interceptorProviders.push({ provide: HTTP_INTERCEPTORS, useClass: RecaptchaInterceptor, multi: true });
}

bootstrapApplication(AppComponent, {
    providers: [
      importProvidersFrom(
        RecaptchaV3Module,
        ApiModule.forRoot(getApiEndpoint()), 
        NgIdleKeepaliveModule.forRoot()
      ),
      provideRouter(APP_ROUTES, 
        withPreloading(PreloadAllModules),
        withComponentInputBinding(), // Allows passing route data directly to component Input parameters
        //withDebugTracing(), // Uncomment to see debug logs for routing
        withInMemoryScrolling({
          scrollPositionRestoration: 'enabled'
        } as InMemoryScrollingOptions),
      ),
      interceptorProviders,
      {
        provide: RECAPTCHA_V3_SITE_KEY,
        useValue: environment.recaptcha.siteKey,
      },
      provideAnimations(),
      provideEnvironmentNgxMask(),
      provideHttpClient(withInterceptorsFromDi())
    ]
  }).catch(err => console.error(err));